module.exports = __webpack_public_path__ + "static/media/owl-and-book.a87a0cc0.svg";